// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-toolbar[data-v-bff827fc]{padding:0 15px}\n", ""]);
// Exports
module.exports = exports;
